// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeEventBoxScoreGetBody = {
  eventId: string;
};

export type typeEventBoxScoreGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    eventId: string;
    sportKey: "football" | "basketball" | "baseball" | "hockey";
    venueName: string | null;
    attendance: number | null;
    asOfAt: string;
    home: {
      teamId: string;
      periodScores: {
        periodKey: string;
        label: string;
        score: number | null;
      }[];
      teamStats: { key: string; label: string; value: string }[];
      categories: {
        categoryKey: string;
        label: string;
        columns: { key: string; label: string }[];
        players: {
          rowKey: string;
          name: string;
          position: string | null;
          isStarter: boolean | null;
          values: string[];
        }[];
      }[];
    };
    away: {
      teamId: string;
      periodScores: {
        periodKey: string;
        label: string;
        score: number | null;
      }[];
      teamStats: { key: string; label: string; value: string }[];
      categories: {
        categoryKey: string;
        label: string;
        columns: { key: string; label: string }[];
        players: {
          rowKey: string;
          name: string;
          position: string | null;
          isStarter: boolean | null;
          values: string[];
        }[];
      }[];
    };
  };
};

export type typeEventBoxScoreGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventBoxScoreGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeEventBoxScoreGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaEventBoxScoreGetBody = {
  type: "object",
  properties: { eventId: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["eventId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createEventBoxScoreGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaEventBoxScoreGetBody);
  }

  return async function postEventBoxScoreGet(
    payload: typeEventBoxScoreGetBody,
  ): Promise<typeEventBoxScoreGetOutput200 | typeEventBoxScoreGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postEventBoxScoreGet" failed before calling the network. #0591a1b80e9d`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#0591a1b80e9d" },
        },
        data: null,
      } as typeEventBoxScoreGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/event/box-score-get`,
      httpMethod: "POST",
      options,
    })) as typeEventBoxScoreGetOutput200 | typeEventBoxScoreGetOutput400;
  };
}
